import { HOTEL_FILTERS_TITLES } from '@hotels/hotel-results/constants/filters';

export function getHotelItemLabel(label: string): string {
  return HOTEL_FILTERS_TITLES[label];
}
